import { useNavigate, useParams } from "react-router";

import { Header, PageContainer } from "@/components";
import { PathNamekAppsRoutes, PathNamekRoutes } from "@/router";

import { MaterialsList } from "./components/materialsList/MaterialsList";
import { MaterialEditor } from "./components/materialForm/MaterialForm";

export function Materials() {
  const { edition } = useParams();
  const navigate = useNavigate();

  const handleOnNew = () => {
    navigate(`/${PathNamekAppsRoutes.CONFIG}/${PathNamekRoutes.CONFIG.MATERIALS}/creacion`);
  };

  return (
    <PageContainer>
      <Header isCreateAllowed={true} title="Materiales" onNew={handleOnNew} />

      <MaterialsList />

      {edition && <MaterialEditor />}
    </PageContainer>
  );
}
